var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cardClass},[_c('div',{staticClass:"external-recipient-card__body"},[_c('p',{staticClass:"external-recipient-card__name"},[_vm._v(_vm._s(_vm.displayName))]),_c('p',{staticClass:"external-recipient-card__status"},[_vm._v(_vm._s(_vm.statusLabel))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }